export const translationEn = {
    common:{
        select: 'Select',
        clear: 'Clear',
    },
    data: {
        "lastUpdated": "Last Updated",
        "status": "Status",
        "source": "Source",
        "space": "Space",
        date: "Date",
    },
    dataview: {
        all: "All",
        jira: "Jira",
        confluence: "Confluence",
        graphApiPeople: "People",
        sharepoint: "Files"
    },
    devmode: {
        Debug: "Debug",
        GuiState: "Gui State",
        Hide: "Hide",
        FeatureFlags: "Feature Flags",
        SearchState: "Search State",
        Sovereign: "Sovereign State",
        Translate: {
            used: "Used",
            notFound: "Not Found"
        },
        UserData: "User Data",
    },

    filter: {
        'data-view': {
            'select-data-sources': "Select data sources",
        },
        time: {
            title: "Time",
            yesterday: "Yesterday",
            lastWeek: "Last Week",
            lastMonth: "Last Month",
            lastYear: "Last Year",
        }

    },
    login: {
        login: "Login",
        logout: "Logout",
        loggedIn: "",
    },
    search: {
        advance: {
            title: "Welcome to your new search experience",
        },


    },
    time:{
        'yesterday': "Yesterday",
        'lastWeek': "Last Week",
        'lastMonth': "Last Month",
        'lastYear': "Last Year",
    },
    //datasources needs code change. These are used in the data view filters.
    'jira-prod': "Jira",
    'confluence-prod': "Confluence",
    'people': "People",
    'sharepoint': "Files",

}